// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3HPyc","wrapper":"styles_wrapper__1C-U0","view":"styles_view__1Dp2D"};